import styled, { css } from 'styled-components';

import Constants from 'app/shared/constants';

// Constellation Components
import {
    spaceMixin,
    Spacer,
    Text,
    token,
} from '@zillow/constellation';

export const StyledItemDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const StyledListingStatusDiv = styled.div`
    margin-bottom: ${spaceMixin('xs')};
`;

export const StyledSpacer = styled(Spacer)`
    flex:1;
`;

export const StyledStatusDiv = styled.div`
    && {
        display: flex;
        flex-direction: row;
        border-color: #ccc;

        ${props => props.theme &&
            props.theme.ns &&
            props.borderTop &&
            css`
                border-top: 1px solid ${token('colors.gray300')};
            `}

        ${props => props.theme &&
            props.theme.ns &&
            css`
                border-bottom: 1px solid ${token('colors.gray300')};
            `}
    }
`;

export const StyledText = styled(Text)`
    ${(props) => {
        switch (props.itemStatus) {
            case Constants.LISTING_STATUS.DECLINED.toLowerCase():
                return css`
                    color: ${token('colors.red500')};
                `;
            case Constants.LISTING_STATUS.POSTED.toLowerCase():
                return css`
                    color: inherit;
                `;
            default:
                return '';
        }
    }}
`;
